import React from 'react';

const MyDropzone = ({ style, getRootProps, getInputProps }) => (
	<section className='container'>
		<div {...getRootProps({ className: 'dropzone', style })}>
			<input {...getInputProps()} multiple />
			<p>Drag 'n' drop some files here, or click to select files</p>
		</div>
	</section>
);

export default MyDropzone;
